import { DecryptModalComponent } from './decrypt-modal/decrypt-modal.component';
import { Component, OnInit, ViewChild, Injector, HostListener } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { BzgModalRef, BzgModalService, BzgToastService } from 'bz-genome-angular';
import { DeploymentConfirmAlertComponent } from './deployment-confirm.component';
import { Store } from '@ngrx/store';
import {
  GetBexHistory,
  SetLocalBexFile,
  UploadBexFile,
  GetCurrentBEXFromServer,
  DownloadTraceFile,
  ApplyBexUpload,
  GetBexImportStatus,
  RemoveSelectedBexFile,
  CancelBexImport,
  GetObjectListMaintenanceReasons
} from './store/actions/upload-bex.actions';
import {
  getHistory,
  isLoadingUpload,
  getBexFromServer,
  getStatus,
  getMaintenanceReasons,
  getApplyStatus,
  isLoadingHistory,
  canReload,
  getStatusApply,
  getIsLoadingTraces
} from './store/selectors/upload-bex.selectors';
import { DeploymentPackageMaintenanceWindowComponent } from './package-maintenance-window/package-maintenance-window.component';
import { PackageImportModalComponent } from './package-import-modal/package-import-modal.component';
import { Router } from '@angular/router';
import {OverlayService} from '../shared/services/overlay.service';
import { PortalInjector } from '@angular/cdk/portal';
import { PACKAGE_VISUALIZER_DATA } from './core/contracts/package-visualizer.data';
import { PackageVisualizerComponent } from './package-visualizer/package-visualizer.component';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { OverlayRef } from '@angular/cdk/overlay';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-deployment',
  templateUrl: './deployment.component.html',
  styleUrls: ['./deployment.component.scss']
})
export class DeploymentComponent implements OnInit {

  constructor(
    private datePipe: DatePipe,
    private _modalService: BzgModalService,
    private _store: Store<IAppState>,
    private _toastService: BzgToastService,
    private router: Router,
    private _overlayService: OverlayService,
    private injector: Injector,
    private _translateService: TranslateService

  ) {
    this.$history = this._store.select(getHistory);
    this.$currentBex = this._store.select(getBexFromServer).pipe(tap((bex) => this._currentBex = bex ? bex.BEX : {}));
    this.$isLoadingHistory = this._store.select(isLoadingHistory);
    this.isLoadingSubscription = this._store
      .select(isLoadingUpload)
      .subscribe(
        loading =>
          (this.isProcessing = this.isLoading =
            this.status === 'InProgess' || this.statusApply === 'LoadingReasons'
              ? true
              : loading)
      );
    this.canReloadSubscription = this._store.select(canReload).subscribe((reload) => this.canReload = reload);
    this.statusApplySubscription = this._store.select(getStatusApply).subscribe((statusApply) => {
      this.statusApply = statusApply;
      this.isProcessing = this.isLoading = statusApply ? true : false;

    });
    this.bexStatusSubscription = this._store.select(getStatus).subscribe((status) => {
      if (status) {
        this.status = status;
        switch (this.status) {
          case 'InProgess':
            this.isLoading = this.isProcessing = true;
            this.listTimeOut.push(setTimeout(() => {
              this._store.dispatch(new GetBexImportStatus());
            }, 3000));
            break;

          case 'Error':
            this._store.dispatch(new RemoveSelectedBexFile());
            break;
          case 'Done':
            this._store.dispatch(new GetObjectListMaintenanceReasons());
            this._store.dispatch(new GetCurrentBEXFromServer());
            break;
          default:
            this.isProcessing = this.statusApply !== 'LoadingReasons' ? false : this.isProcessing;
            break;
        }
      }
    });

    this.bexApplyStatusSubscription = this._store.select(getBexFromServer).subscribe((data) => {
      if (data && data.BEX && data.BEX.DescriptionStateBEX) {
        this.status = data.BEX.DescriptionStateBEX;
        this.isLoading = this.status === 'Begin';
        switch (this.status) {
          case 'Begin':
            this.isProcessing = true;
            this.listTimeOut.push(setTimeout(() => {
              this._store.dispatch(new GetCurrentBEXFromServer());
            }, 3000));
            break;
          case 'Done':
          case 'Error':
            this._store.dispatch(new RemoveSelectedBexFile());
            this._store.dispatch(new GetBexHistory());
            break;
          default:
            this._store.dispatch(new GetBexImportStatus());
            this.isProcessing = this.statusApply !== 'LoadingReasons' ? false : this.isProcessing;
            break;
        }
      }
    });



    this.maintenanceReasonsSubscription = this._store.select(getMaintenanceReasons).subscribe((reasons) => {
      if (reasons) {
        this.maintenanceReasons = reasons;
      } else {
        this.maintenanceReasons = [];
      }
    });

    this._translateService.get('DEPLOYMENT.RELOAD').subscribe((message: string) => {
      this.reloadMessage = message;
    });

    this.isLoadingSubscription = this._store.select(getIsLoadingTraces).subscribe((loading: boolean) => {
      this.isProcessing = loading;
    });
  }

  @ViewChild('file', { static: false}) file;
  public $history: Observable<any>;
  public $isLoadingHistory: Observable<any>;
  public $isLoading: Observable<boolean>;
  public $currentBex: Observable<any>;
  public $statusApply: Observable<string>;
  public $isLoadingTraces: Observable<boolean>;
  public bexStatusSubscription: Subscription;
  public maintenanceReasonsSubscription: Subscription;
  public bexApplyStatusSubscription: Subscription;
  public isLoadingSubscription: Subscription;
  public canReloadSubscription: Subscription;
  public statusApplySubscription: Subscription;
  public isLoadingTracesSubscription: Subscription;
  public uploadedFileData: any = {};
  public isLoading: boolean;
  public canReload: boolean;
  public isProcessing = false;

  private _currentBex: any;
  private reloadMessage: string;
  private listTimeOut: any[] = [];
  private overlayPackageVisualizer: OverlayRef;

  status = 'NotStarted';
  statusApply = 'NotStarted';
  history: Array<any> = [];
  uploadModal: BzgModalRef;
  maintenanceReasons: string[] = [];
  @HostListener('window:beforeunload', ['$event'])
  @HostListener('window:pagehide', ['$event'])
  doSomething($event) {
    if (!this.canDeactivate()) {
      $event.returnValue='Changes you made may not be saved.';
    }
  }

  ngOnInit() {
    this._store.dispatch(new GetBexHistory());
  }

  ngOnDestroy() {
    if (this.bexStatusSubscription) {
      this.bexStatusSubscription.unsubscribe();
    }

    if (this.maintenanceReasonsSubscription) {
      this.maintenanceReasonsSubscription.unsubscribe();
    }

    if (this.isLoadingSubscription) {
      this.isLoadingSubscription.unsubscribe();
    }

    if (this.canReloadSubscription) {
      this.canReloadSubscription.unsubscribe();
    }

    if (this.bexApplyStatusSubscription) {
      this.bexApplyStatusSubscription.unsubscribe();
    }

    if(this.isLoadingTracesSubscription) {
      this.isLoadingTracesSubscription.unsubscribe();
    }

    if(this.overlayPackageVisualizer){
      this.overlayPackageVisualizer.dispose();
    }

    this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
  }

  public uploadPackage(file) {
    let fileDate: string;
    if (file) {
      fileDate = new Date(file.lastModified || file.lastModifiedDate).toISOString();
      this.uploadedFileData = { date: fileDate, name: file.name };
    }
    const modal = this._modalService.open(
      DeploymentConfirmAlertComponent,
      {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        data: { fileName: file.name, fileDate: this.datePipe.transform(fileDate, 'medium') }
      });

    this._store.dispatch(new SetLocalBexFile(file));

    modal.afterClosed().subscribe((result: string) => {
      if (result === 'confirm') {
        this._store.dispatch(new UploadBexFile());
      }
    });
  }

  public showMaintenanceWindow() {
    const modal = this._modalService.open(
      DeploymentPackageMaintenanceWindowComponent, {
      closeOnBackdropClick: true,
      closeOnRouterNavigation: true,
      data: { objectList: this.maintenanceReasons }
    });

    modal.afterClosed().subscribe((result: string) => {
      if (result === 'confirm') {
        this.router.navigate(['mc', 'Maintenance'], { queryParams: { tab: 1 } });
      }
    });
  }

  public importPackage() {
    const modal = this._modalService.open(PackageImportModalComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        fileData: {
          name: this._currentBex.Filename,
          date: this.datePipe.transform(this._currentBex.ImportTime, 'medium')
        },
        objList: this.maintenanceReasons
      }
    });

    modal.afterClosed().subscribe((result: string) => {
      if (result === 'confirm') {
        this._store.dispatch(new ApplyBexUpload());
      }
    });
  }

  public downloadFile(register: any) {
    this._store.dispatch(new DownloadTraceFile(register.Id));
  }

  public async openPackageVisualizer(history:IBexPackage) {
    const injector = this.createInjector(history);
    this.overlayPackageVisualizer = this._overlayService.show(
      $('.bmc-deployment-bex-container')[0],
      PackageVisualizerComponent,
      injector,
      async () => { }
    );
  }

  public cancelImport() {
    this._store.dispatch(new CancelBexImport());
  }

  public canDeactivate(): boolean {
    return this.canReload;
  }

  private createInjector(history: IBexPackage): PortalInjector {
    const injectionTokens = new WeakMap();
    injectionTokens.set(PACKAGE_VISUALIZER_DATA, {
      packageId: history.Id,
      packageName: history.Filename
    });
    return new PortalInjector(this.injector, injectionTokens);
  }
}
